<div fxFlex class='forms-container'>
  <!-- Forms header -->
  <div #vrmInterventionHeader class='forms-header' fxLayout='row' fxLayoutGap='5px'>
    <div fxFlex class='header-title'>{{ 'FORM.managerLedCoaching' | translate }}</div>

    <button
      class='widen-restore-form'
      type='button'
      mat-icon-button
      [matTooltip]="'Widen or Restore Form'"
      (click)='toggleFormPaneWidth()'
      [disabled]='!cService.isLargePcViewport'
    >
      <mat-icon *ngIf='dfService.widenForm; else showMaximizeIcon'>compare_arrows</mat-icon>
      <ng-template #showMaximizeIcon>
        <mat-icon>swap_horiz</mat-icon>
      </ng-template>
    </button>

    <button type='button' mat-icon-button (click)='dfService.closeFormPane()'>
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class='form-info' *ngIf='dfService.launchedIntervention === dfService.pccReviewInterventionValue'>
    <small>
      <span class='bold'>{{ 'GENERIC.assignedCrash' | translate }}:&nbsp;</span>
      {{ dfService.selectedPccReviewCrash?.description ??  dfService.launchedInterventionHistory?.coachingReason}}
    </small>
  </div>

  <intervention-info [selectedInterventionHistory]='dfService.launchedInterventionHistory'></intervention-info>

  <!-- FORMS: Dynamic Forms -->
  <vrm-dynamic-forms
    *ngIf='dfService.dynamicFormIsVisible; else loadingDynamicForm'
    (onSave)='emitSave($event)'
    (onComplete)='emitComplete($event)'
    [fontsize]='16'
    [formBodyHeight]="cService.isPcViewport || dfService.widenForm ? '64vh' : ''"
    [autoSaveForm]='dfService.interventionsToAutosave.includes(dfService.launchedIntervention) ? true : false'
    [showSaveButton]='dfService.interventionsToAutosave.includes(dfService.launchedIntervention) ? true : false'
    [readonly]='dfService.formIsReadonly'
    [formComponentStructure]='dfService.currentFormStruct'
    [existingFormData]='dfService.selectedDynamicFormData'
    [permission]='cService.userProfile.companySettings'
    [isMobileViewport]='cService.isMobileViewport'
    [companyColor]="'#' + cService.userProfile?.HqColour"
    [languageCode]='cService.selectedLanguage.code'
    [isRtl]='cService.selectedLanguage?.isRtl'
    [saveButtonOptions]='customSaveButton'
    [printButtonOptions]='
			dfService.interventionsWithCustomPrintButton.includes(dfService.launchedIntervention)
				? customPrintButton
				: null
		'
    [environment]="environment"
  >
  </vrm-dynamic-forms>

  <ng-template #loadingDynamicForm>
    <div class='text-align-c padding-t-20 padding-b-20 bold'>{{ 'FORM.generatingForm' | translate }}...</div>
  </ng-template>
</div>
